import { render, staticRenderFns } from "./DniFieldBusinessRegister.vue?vue&type=template&id=86d7da00&scoped=true&"
import script from "./DniFieldBusinessRegister.vue?vue&type=script&lang=ts&"
export * from "./DniFieldBusinessRegister.vue?vue&type=script&lang=ts&"
import style0 from "./DniFieldBusinessRegister.vue?vue&type=style&index=0&id=86d7da00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d7da00",
  null
  
)

export default component.exports